import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./MaterialConsumption.css";
import "../src/assets/styles/bootstrap-4.4.1.css";
import "../src/assets/styles/style.css";

import {
  GetMaterialConsumptionList,
  postMaterialConsumptionList,
} from "./apiService";
import { useEvent } from "./EventDetailsContext";
import EventName from "./EventName";
import CustomAlert from "./CustomAlert";

const MaterialConsumption = () => {
  const { eventDetails } = useEvent();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const locationRefs = useRef([]);

  const [formData, setFormData] = useState({
    printedMaterial: { id: "", quantity: "" },
    packaging: { id: "", quantity: "" },
    plastic: { id: "", quantity: "" },
    paper: { id: "", quantity: "" },
    transportedMaterials: [
      {
        modeOfSupply: "",
        locationOfSupplier: "",
        materialName: "",
        distance: 0,
      },
    ],
  });
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState("success");
  const [datevalidation, setDateValidation] = useState(null);

  useEffect(() => {
    if (eventDetails) {
      const fetchData = async () => {
        try {
          const data = await GetMaterialConsumptionList(eventDetails.eventId);

          const transported =
            data.transportedMaterials.length > 0
              ? data.transportedMaterials.map((item) => ({
                  id: item.transportedMaterialId,
                  modeOfSupply: item.travelModeId === 15 ? "Truck" : "LMV",
                  locationOfSupplier: item.location,
                  materialName: item.materialName,
                  distance: item.distance,
                }))
              : [
                  {
                    modeOfSupply: "",
                    locationOfSupplier: "",
                    materialName: "",
                    distance: 0,
                  },
                ];

          setFormData((prev) => ({
            ...prev,
            printedMaterial: {
              id: data.materialConsumptions[0].materialConsumptionId,
              quantity: data.materialConsumptions[0].quantity,
            },
            packaging: {
              id: data.materialConsumptions[1].materialConsumptionId,
              quantity: data.materialConsumptions[1].quantity,
            },
            plastic: {
              id: data.materialConsumptions[2].materialConsumptionId,
              quantity: data.materialConsumptions[2].quantity,
            },
            paper: {
              id: data.materialConsumptions[3].materialConsumptionId,
              quantity: data.materialConsumptions[3].quantity,
            },
            transportedMaterials: transported,
          }));
        } catch (error) {
          setError(error);
        } finally {
          setLoading(false);
        }
      };
      fetchData();
    }
  }, [eventDetails]);

  const initializeAutocomplete = (index) => {
    if (!locationRefs.current[index]) return;

    if (locationRefs.current[index].autocomplete) {
      window.google.maps.event.clearInstanceListeners(
        locationRefs.current[index].autocomplete
      );
    }

    const autocomplete = new window.google.maps.places.Autocomplete(
      locationRefs.current[index],
      { strictBounds: false }
    );

    autocomplete.setFields(["formatted_address", "geometry.location"]);

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();
      console.log("place", place);
      if (!place?.geometry?.location) return;

      setFormData((prev) => {
        const newMaterials = [...prev.transportedMaterials];
        newMaterials[index] = {
          ...newMaterials[index],
          locationOfSupplier: place.formatted_address || "",
        };
        return { ...prev, transportedMaterials: newMaterials };
      });
    });

    locationRefs.current[index].autocomplete = autocomplete;
  };

  useEffect(() => {
    const initPlaces = () => {
      if (window.google?.maps?.places) {
        setTimeout(() => {
          formData.transportedMaterials.forEach((_, i) => {
            initializeAutocomplete(i);
          });
        }, 100);
      }
    };

    if (window.google?.maps?.places) {
      initPlaces();
    } else {
      const script = document.createElement("script");
      script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyCpdevcXjKt9CVD1n8chB59MGW0d1uT2dg&libraries=places`;
      script.async = true;
      script.defer = true;
      script.onload = initPlaces;
      document.head.appendChild(script);
    }
  }, [formData.transportedMaterials]);

  useEffect(() => {
    const handleInitialMount = () => {
      if (formData.transportedMaterials.length > 0) {
        setTimeout(() => {
          if (window.google?.maps?.places) {
            formData.transportedMaterials.forEach((_, i) => {
              initializeAutocomplete(i);
            });
          }
        }, 500);
      }
    };

    const timer = setTimeout(handleInitialMount, 500);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    locationRefs.current = locationRefs.current.slice(
      0,
      formData.transportedMaterials.length
    );
  }, [formData.transportedMaterials.length]);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error.message}</div>;
  }

  const handleChange = (e, field, subField, index = null) => {
    if (field === "transportedMaterials") {
      const updatedMaterials = [...formData.transportedMaterials];
      updatedMaterials[index] = {
        ...updatedMaterials[index],
        [subField]: e.target.value,
      };
      setFormData({ ...formData, transportedMaterials: updatedMaterials });
    } else {
      setFormData({
        ...formData,
        [field]: {
          ...formData[field],
          [subField]: e.target.value,
        },
      });
    }
  };

  console.log("formData", formData.printedMaterial.quantity);
  const validateForm = () => {
    const { printedMaterial, packaging, plastic, paper, transportedMaterials } =
      formData;
    return !(
      Number(printedMaterial.quantity) < 0 ||
      Number(packaging.quantity) < 0 ||
      Number(plastic.quantity) < 0 ||
      Number(paper.quantity) < 0 ||
      transportedMaterials.some((material) => Number(material.distance) < 0)
    );
  };

  const travelModeMapping = {
    Truck: 15,
    LMV: 14,
  };

  const getMaterialId = (materialKey) => {
    const materialMapping = {
      printedMaterial: 1,
      packaging: 2,
      plastic: 3,
      paper: 4,
    };
    return materialMapping[materialKey];
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isValid = true;
    let errorMessage = "";

    formData.transportedMaterials.forEach((item, index) => {
      if (item.materialName && !item.modeOfSupply) {
        isValid = false;
        errorMessage += `Row ${index + 1}: Mode of supply is required\n`;
      }
      if (item.materialName && !item.locationOfSupplier) {
        isValid = false;
        errorMessage += `Row ${index + 1}: Location is required\n`;
      }
    });

    ["printedMaterial", "packaging", "plastic", "paper"].forEach((material) => {
      const quantity = Number(formData[material].quantity);
      if (quantity < 0) {
        isValid = false;
        errorMessage += `${material} quantity cannot be negative\n`;
      }
    });

    if (!isValid) {
      setAlertMessage(errorMessage);
      setAlertType("error");
      setShowAlert(true);
      return;
    }

    if (!validateForm()) {
      return;
    }

    const postData = {
      materialConsumptions: [
        "printedMaterial",
        "packaging",
        "plastic",
        "paper",
      ].map((material) => ({
        materialConsumptionId: formData[material].id,
        eventId: eventDetails.eventId,
        materialId: getMaterialId(material),
        quantity: Number(formData[material].quantity),
      })),
      transportedMaterials: formData.transportedMaterials.map((item) => ({
        eventId: eventDetails.eventId,
        travelModeId: travelModeMapping[item.modeOfSupply] || 0,
        location: item.locationOfSupplier,
        materialName: item.materialName,
        distance: 0,
      })),
    };
    console.log("postData", postData);
    try {
      await postMaterialConsumptionList(postData);
      setAlertMessage("Data saved successfully");
      setAlertType("success");
      setShowAlert(true);
    } catch (error) {
      console.error("Error saving material consumption data:", error);
      setAlertMessage(
        "Error saving data. Please check your inputs and try again."
      );
      setAlertType("error");
      setShowAlert(true);
    }
  };

  const handleCloseAlert = () => {
    setShowAlert(false);
    if (alertType === "success") {
      navigate("/events/post-event-planning/waste-generation");
    }
  };
  const handleAddTransportedRow = () => {
    setFormData((prev) => ({
      ...prev,
      transportedMaterials: [
        ...prev.transportedMaterials,
        {
          modeOfSupply: "",
          locationOfSupplier: "",
          materialName: "",
          distance: 0,
        },
      ],
    }));
  };

  const handleRemoveTransportedRow = (index) => {
    if (formData.transportedMaterials.length <= 1) return;

    setFormData((prev) => ({
      ...prev,
      transportedMaterials: prev.transportedMaterials.filter(
        (_, i) => i !== index
      ),
    }));
  };

  const handleTransportedChange = (e, index, field) => {
    const { value } = e.target;
    setFormData((prevFormData) => {
      const newMaterials = [...prevFormData.transportedMaterials];
      newMaterials[index] = {
        ...newMaterials[index],
        [field]: value,
      };
      return {
        ...prevFormData,
        transportedMaterials: newMaterials,
      };
    });
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-12">
          <form
            onSubmit={handleSubmit}
            onKeyDown={(e) => {
              e.key === "Enter" && e.preventDefault();
            }}
            className="material-consumption-form"
          >
            <div className="row">
              <div className="col-md-12">
                <h3>Material Consumption</h3>
                {datevalidation && (
                  <div
                    className="alert alert-danger d-flex align-items-center"
                    role="alert"
                  >
                    <div>{datevalidation}</div>
                  </div>
                )}
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Material</th>
                        <th>Quantity (kg)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Printed Material (Non-Paper)</td>
                        <td>
                          <input
                            required
                            type="number"
                            className="form-control"
                            value={formData.printedMaterial.quantity}
                            onChange={(e) =>
                              handleChange(e, "printedMaterial", "quantity")
                            }
                            min={0}
                            max={9999999999}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Packaging</td>
                        <td>
                          <input
                            required
                            type="number"
                            className="form-control"
                            value={formData.packaging.quantity}
                            onChange={(e) =>
                              handleChange(e, "packaging", "quantity")
                            }
                            min={0}
                            max={9999999999}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Plastic</td>
                        <td>
                          <input
                            required
                            type="number"
                            className="form-control"
                            value={formData.plastic.quantity}
                            onChange={(e) =>
                              handleChange(e, "plastic", "quantity")
                            }
                            min={0}
                            max={9999999999}
                          />
                        </td>
                      </tr>
                      <tr>
                        <td>Paper</td>
                        <td>
                          <input
                            required
                            type="number"
                            className="form-control"
                            value={formData.paper.quantity}
                            onChange={(e) =>
                              handleChange(e, "paper", "quantity")
                            }
                            min={0}
                            max={9999999999}
                          />
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <h3>Transported Materials</h3>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Mode of Supply</th>
                        <th>Location of Supplier</th>
                        <th>Material Name</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {formData.transportedMaterials.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <select
                              className="form-control"
                              value={item.modeOfSupply}
                              onChange={(e) =>
                                handleTransportedChange(
                                  e,
                                  index,
                                  "modeOfSupply"
                                )
                              }
                            >
                              <option value="">Select Mode</option>
                              <option value="Truck">Truck</option>
                              <option value="LMV">LMV</option>
                            </select>
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              ref={(el) => (locationRefs.current[index] = el)}
                              value={item.locationOfSupplier}
                              onChange={(e) =>
                                handleTransportedChange(
                                  e,
                                  index,
                                  "locationOfSupplier"
                                )
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control"
                              value={item.materialName}
                              onChange={(e) =>
                                handleTransportedChange(
                                  e,
                                  index,
                                  "materialName"
                                )
                              }
                            />
                          </td>
                          <td>
                            <div className="action-buttons">
                              {index ===
                                formData.transportedMaterials.length - 1 && (
                                <div
                                  className="PlusBtn"
                                  onClick={handleAddTransportedRow}
                                >
                                  <i
                                    className="fa fa-plus-circle"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                              )}
                              {formData.transportedMaterials.length > 1 && (
                                <div
                                  className="MinusBtn"
                                  onClick={() =>
                                    handleRemoveTransportedRow(index)
                                  }
                                >
                                  <i
                                    className="fa fa-minus-circle"
                                    aria-hidden="true"
                                  ></i>
                                </div>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12 text-right">
                <button type="submit" className="btn save-button">
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      {showAlert && (
        <CustomAlert
          message={alertMessage}
          type={alertType}
          onClose={handleCloseAlert}
        />
      )}
    </div>
  );
};

export default MaterialConsumption;
